<template>
  <popover-right v-model="isShow" width='1050px' :closed="cancel" :completeClose="cancel">
    <h1 class="popover-right-title" style="padding-left: 20px;">{{titleName}}</h1>
    <div class="system-card-detail">
      <div class="b-conditions-style" style="padding: 5px 0 0;">
        <div class="b-con-form" v-if="type == 'total' || type == 'cardTotal'">
          <label class="c-label">归属人</label>
          <single-auto-complete class="b-con-filter-area" v-bind:model_id.sync="paramters.admin_id" :selectOptions="{apiType: 'agent'}" />
        </div>
        <div class="b-con-form">
          <label class="c-label">获客方式</label>
          <el-select class="b-con-filter-area" popper-class="condition-popover-style" v-model="paramters.grab_type" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(status, key) in options.resident_grab_type" :key="key" :label="status" :value="key"></el-option>
          </el-select>
        </div>
        <div class="b-con-form">
          <label class="c-label">来源方式</label>
          <el-select class="b-con-filter-area" popper-class="condition-popover-style" v-model="paramters.source" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(status, key) in options.customer_sources" :key="key" :label="status" :value="key"></el-option>
          </el-select>
        </div>
        <div class="b-con-form" v-if="type == 'cardTotal'">
          <label class="c-label">归属套餐</label>
          <el-select class="b-con-filter-area" popper-class="condition-popover-style" v-model="paramters.set_id" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(set, i) in sets" :key="i" :label="set.name" :value="set.id"></el-option>
          </el-select>
        </div>
        <div class="c-con-search-btn">
          <button class="global-btn primary size-1" @click="handleSearch">搜索</button>
        </div>
      </div>
      <cu-table :isLoading="isLoading" :data="list" :pageData="condition" @currentChange="currentChange" class="border-none">
        <el-table-column label="经纪人姓名" min-width="100" v-if="type == 'total' || type == 'cardTotal'">
          <p slot-scope="scope">{{scope.row.admin_name || '--'}}{{scope.row.is_cancel == 1 ? '(已离职)' : ''}}</p>
        </el-table-column>
        <el-table-column label="客户手机号" min-width="100">
          <p slot-scope="scope" class="entery-name" @click="toCustomeDetail(scope.row)">{{scope.row.contact_tel || '--'}}</p>
        </el-table-column>
        <el-table-column label="消耗积分数" min-width="100">
          <p slot-scope="scope">消耗 {{scope.row.point_cost || 0}} 积分</p>
        </el-table-column>
        <el-table-column label="来源" min-width="150">
          <p slot-scope="scope">{{scope.row.source_total_string || '--'}}</p>
        </el-table-column>
        <el-table-column label="获客方式" min-width="100">
          <p slot-scope="scope">{{scope.row.grab_type_name || '--'}}</p>
        </el-table-column>
        <el-table-column label="终端" min-width="100" v-if="type == 'cardTotal'">
          <p slot-scope="scope">{{scope.row.terminal_name || '--'}}</p>
        </el-table-column>
        <el-table-column label="归属套餐" min-width="100" v-if="type == 'cardTotal'">
          <p slot-scope="scope">{{scope.row.set_name || '无'}}</p>
        </el-table-column>
        <el-table-column label="获客时间" min-width="150" v-if="type == 'cardTotal'">
          <p slot-scope="scope">{{scope.row.created_at || '--'}}</p>
        </el-table-column>
        <el-table-column label="抢客时间" min-width="150" v-else>
          <p slot-scope="scope">{{scope.row.created_at || '--'}}</p>
        </el-table-column>
        <el-table-column label="报名时间" min-width="150">
          <p slot-scope="scope" v-analysis-time="scope.row.sign_up_time"></p>
        </el-table-column>
      </cu-table>
    </div>
  </popover-right>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import CuTable from '@/components/cTable';
import SingleAutoComplete from '@/components/select/SingleAutoComplete';
import {getCardGainedCustome, getCombos} from '@/api/system';
import { getDetailPermission } from '@/api/custome';
export default{
  name: 'HouseCardDetail',
  components: {PopoverRight, CuTable, SingleAutoComplete},
  props: {
    value: String,
    cardId: Number,
    type: String,
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    emitName: String
  },
  computed: {
    isShow () {
      return this.value === 'systemHousecardDetail';
    },
    titleName () {
      if (this.type == 'total') return `${this.detail.taocan_name} - 获客详情`;
      if (this.type == 'cardTotal') return `云来客获客明细`;
      return `${this.detail.admin_name} - 获客详情`;
    }
  },
  data () {
    return {
      isLoading: false,
      list: [],
      paramters: {
        admin_id: '',
        source: '',
        grab_type: '',
        set_id: ''
      },
      condition: {
        per_page: 15,
        page: 1
      },
      options: {},
      sets: []
    }
  },
  async created() {
    this.initList();
    this.initSets();
    this.options = await this.$store.dispatch('initConfig', ['resident_grab_type', 'customer_sources']);
  },
  methods: {
    cancel () {
      this.$emit('input', false);
    },
    async initList () {
      this.isLoading = true;
      try {
        const params = {
          ...this.condition,
          ...this.paramters
        };
        if (this.type != 'cardTotal') {
          params.set_id = this.cardId;
        }
        // 总计不需要admin_id
        if (this.type != 'total' && this.type != 'cardTotal') {
          params.admin_id = this.detail.admin_id;
        }
        const res = await getCardGainedCustome(params);
        this.list = res.data || [];
        this.$set(this.condition, 'total', res.total);
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      } finally {
        this.isLoading = false;
      }
    },
    async initSets () {
      try {
        const res = await getCombos();
        this.sets = res;
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    currentChange (page) {
      this.condition.page = page;
      this.initList();
    },
    handleSearch () {
      this.condition.page = 1;
      this.initList();
    },
    async toCustomeDetail (row) {
      try {
        await getDetailPermission(row.customer_id);
        this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
          customerId: row.customer_id
        }}); 
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
  },
}
</script>
<style scoped>
.entery-name{
  color: #3168FF !important;
}
</style>
<style lang="less">
@import url('~@/assets/style/base/condition.less');
.system-card-detail{
  padding: 0 20px;
  .el-table.b-custom-table{
    height: initial !important;
    margin-top: 20px;
    border-radius: 3px;
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
    .el-table__body-wrapper{
      height: initial !important;
    }
  }
}
</style>